import moment from 'moment'

const formatDate = (date, dateType) => moment(date).format(dateType || 'MMMM D · YYYY')

export default formatDate;